'use strict';

/**
 *
 * @name: userNav
 *
 */

import DirectiveTemplate from './nn-user-navigation.directive.html';
import './nn-user-navigation.directive.scss';

function UserNavDirective(
  $sce,
  $rootScope,
  $state,
  $document,
  apiUserService,
  apiNotificationsService,
  navigationAnalytics
) {

  'ngInject';

  return {
    restrict: 'E',
    replace: true,
    template: DirectiveTemplate,
    link: function(scope) {

      /*
       *
       * @CONFIG
       *
       */
      var rootWatchers = {};
      scope.notifications = [];
      scope.navigationAnalytics = navigationAnalytics;
      scope.$sce = $sce;

      /*
       *
       * @PUBLIC
       *
       */

      scope.logout = function() {

        $rootScope.header.userNav.visible = false;
        return apiUserService.logout();
      };

      scope.tabs = {
        current: 'notifications',
        show: function(name) {

          this.current = name;
        }
      };

      scope.myAccountClick = function() {

        if ($rootScope.bWidth < 800) {

          scope.tabs.show('menu');
        } else {

          scope.navigationAnalytics.shortcut('Feed');
          $state.go('main.ucp.accountFeed');
        }
      };

      /*
       *
       * @PRIVATE
       *
       */

      function watchPanelToggle() {

        rootWatchers.navVisibility = $rootScope.$watch('header.userNav.visible', function(newVal, oldVal) {

          if (newVal !== oldVal && typeof oldVal !== 'undefined') {

            switch (newVal) {

              case true:

                apiNotificationsService.loadUserFeedNotifications();
                break;

              case false:

                markAsRead();
                break;
            }
          }
        });
      }

      function markAsRead() {

        if ($rootScope.notifications.hasUnread) {

          apiNotificationsService
            .markAsRead()
            .then(function() {

              $rootScope.notifications.counter = 0;
            });
        }
      }

      /*
       *
       * @INIT
       *
       */

      // Also loads notifications at the beginning and in interval later.
      apiNotificationsService.watchAndPoll();
      watchPanelToggle();

      scope.$on('$destroy', () => {
        Object.keys(rootWatchers).forEach( killWatcherKey => {
          rootWatchers[killWatcherKey]();
        });
      })
    }
  };
}

export default UserNavDirective;



// WEBPACK FOOTER //
// ./app/components/nn-navigation/nn-user-navigation/nn-user-navigation.directive.js